import { render } from "./status.vue?vue&type=template&id=688377b9&scoped=true"
import script from "./status.vue?vue&type=script&lang=js"
export * from "./status.vue?vue&type=script&lang=js"

import "./status.vue?vue&type=style&index=0&id=688377b9&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-688377b9"

export default script